import { defineComponent as I, computed as b, ref as S, watch as z, createBlock as C, openBlock as _, unref as c, withCtx as T, createVNode as m } from "vue";
import { NodeViewWrapper as y, NodeViewContent as A } from "@tiptap/vue-3";
import { nanoid as B } from "nanoid";
import F from "../../../EditorHandle.vue.js";
import { editEventHandlers as g, NodeEditEvent as k } from "../../../events/index.js";
import { useIsEditable as U } from "../../../../hooks/useIsEditable.js";
import { getCustomTabsInputId as V } from "./helpers.js";
import H from "./ScalarTabs.vue.js";
const G = /* @__PURE__ */ I({
  __name: "CustomTabs",
  props: {
    decorations: {},
    selected: { type: Boolean },
    updateAttributes: { type: Function },
    deleteNode: { type: Function },
    node: {},
    view: {},
    getPos: { type: Function },
    innerDecorations: {},
    editor: {},
    extension: {},
    HTMLAttributes: {}
  },
  setup(h) {
    const t = h, d = b(
      () => t.node.content.content
    ), w = b(() => d.value.map((e) => e.attrs)), { isEditable: p } = U(t.editor), { uid: P } = t.node.attrs, s = S(0), N = () => {
      const e = t.getPos(), { childCount: n } = t.node.content, { tr: o, schema: i } = t.editor.view.state, a = B(), r = i.nodes.custom_container.createAndFill({
        name: `Tab #${n + 1}`,
        uid: a
      }), l = e + t.node.content.size + 1;
      r && o.insert(l, r), t.editor.view.dispatch(o), s.value = n;
    }, f = (e, n = !1) => {
      let o = t.getPos();
      for (let i = 0; i < e; i++)
        o += d.value[i].nodeSize;
      return n ? o += d.value[e].nodeSize : o++, o;
    }, u = (e) => {
      t.editor.commands.focus(e), t.editor.commands.setTextSelection(e);
    }, x = (e) => {
      const n = d.value[s.value], o = f(s.value);
      g.editNode(
        e,
        {
          ...t,
          metadata: {
            attrs: n.attrs,
            position: o,
            remove: () => {
              if (d.value.length > 1) {
                s.value && s.value--;
                const { tr: i } = t.editor.view.state;
                if (i.deleteRange(o, o + n.nodeSize - 1), t.editor.view.dispatch(i), s.value === 0) {
                  const a = d.value[s.value + 1], r = a.attrs.uid, l = a.nodeSize, v = document.getElementById(
                    V(r)
                  );
                  if (!v) return;
                  v.checked = !0;
                  const E = o - 1 + l;
                  u(E);
                }
              } else {
                const i = t.getPos() - 1;
                t.deleteNode(), u(i);
              }
              g.editNode(null, null, null);
            }
          }
        },
        k.Tab
      );
    };
    return z(s, (e) => {
      if (!p.value) return;
      const n = f(e, !0);
      u(n);
    }), (e, n) => (_(), C(c(y), { class: "guide-node-component" }, {
      default: T(() => [
        m(F, {
          editor: e.editor,
          getPos: e.getPos,
          node: e.node,
          shift: "14px"
        }, null, 8, ["editor", "getPos", "node"]),
        m(H, {
          currentTabIndex: s.value,
          "onUpdate:currentTabIndex": n[0] || (n[0] = (o) => s.value = o),
          children: w.value,
          isEditable: c(p),
          uid: c(P),
          onAddTab: N,
          onEditTab: x
        }, {
          default: T(() => [
            m(c(A), { class: "custom-tabs-content" })
          ]),
          _: 1
        }, 8, ["currentTabIndex", "children", "isEditable", "uid"])
      ]),
      _: 1
    }));
  }
});
export {
  G as default
};
